import { DataFlowExpression } from './dataflowexpression';

import { Owned } from '../base/named';
import { Metamodel } from '../base/model';
import { IModel, IViolation } from '../base/annotation';
import { BaseRowModifierTransformation } from './base-row-modifier-transformation';

export enum AlterRowAction {
    Insert = 'insertIf',
    Update = 'updateIf',
    Delete = 'deleteIf',
    Upsert = 'upsertIf'
}

@Metamodel.model({
    name: 'alterRowIfCondition'
})
export class AlterRowIfCondition extends Owned {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.Action,
        constraint: {
            required: true
        }
    })
    public action: AlterRowAction;

    @Metamodel.attribute({
        display: stringResources.Expression,
        constraint: {
            required: true,
            validator: AlterRowIfCondition.validateConditionExpression
        }
    })
    public conditionExpression: DataFlowExpression = BaseRowModifierTransformation.createExpression(this);

    private static validateConditionExpression(alterRowIfCondition: AlterRowIfCondition, conditionExpression: DataFlowExpression): IViolation[] | undefined {
        if (!conditionExpression.expression) {
            return [{
                context: alterRowIfCondition,
                message: () => stringResources.DataFlowColumnTemplateConditionRequiredError
            }];
        }
        return undefined;
    }

}
